var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5322 13.0779C21.9024 13.2619 21.9021 13.79 21.5318 13.9736L12.1885 18.6042C12.0465 18.6745 11.8793 18.6738 11.7383 18.6015L2.48103 13.8557C2.11516 13.6682 2.11894 13.1438 2.48765 12.9622L11.7227 8.42211C11.8624 8.35355 12.0266 8.35406 12.166 8.42333L21.5322 13.0779Z",
    fill: "current",
    stroke: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5555 10.1979C21.9257 10.3819 21.9254 10.9099 21.5551 11.0935L12.2118 15.7242C12.0698 15.7945 11.9027 15.7938 11.7616 15.7215L2.50435 10.9757C2.13848 10.7882 2.14226 10.2638 2.51096 10.0822L11.746 5.54209C11.8857 5.47353 12.0499 5.47404 12.1893 5.54331L21.5555 10.1979Z",
    fill: "current",
    stroke: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayMode);
export default __webpack_public_path__ + "static/media/OverlayMode.179ff696af299bb41b5e38cab6497b5f.svg";
export { ForwardRef as ReactComponent };